// Module
var code = "<div> <p> <input type=\"checkbox\" class=\"filled-in\" ng-checked=\"$ctrl.item.value == 'true'\" disabled=\"disabled\"/> <label>{{$ctrl.item.label}}</label> </p> </div> ";
// Exports
export default code;